export const appVersion = process.env.REACT_APP_KINKEEPER_VERSION || '1.1.0';
export const appName = process.env.REACT_APP_NAME || "KinKeeper";